export default "assets/map-cavale-f6ab8685.jpg";